export enum OrderFlags {
    MADERA = "madera",
    METHANE = "methane",
    SUGAR_CONTENT = "sugar content",
    IGNORE_FORECASTED_RAINFALL = "ignore forecasted rainfall",
    CLOUDY = "cloudy",
    DATA_PRESERVATION = "data preservation",
    RELAXED_S2_MASKING = "relaxed S2 masking",
    IGNORE_USER_IRRIGATION = "ignore user irrigation",
    SUB_PIXEL_MOISTURE = "sub pixel moisture",
    STATIC_TILE = "static tile",
    DESERT_STRESS = "desert stress",
}
